const mainSearchForm = {
  flights: "الرحلات الجوية", // translated 
  tours: "جولات", // translated 
  hotel: "الفندق", // translated 
  hotels: "الفنادق", // translated 
  services: "خدمات", // translated 
  search: "يبحث", // translated 
  destination: "وجهة", // translated 
  includedServices: "الخدمات المضمنة", // translated 
  packageDuration: "مدة الحزمة", // translated 
  checkInOut: "تسجيل الدخول والخروج", // translated 
  guests: "ضيوف", // translated 
  adults: "الكبار", // translated 
  children: "أطفال", // translated 
  child: "طفل", // translated 
  age: "عمر", // translated 
  yearsOld: "سنوات من العمر", // translated 
  rooms: "غرف", // translated 
  close: "يغلق", // translated 
  searchType: "نوع البحث", // translated 
  accommodation: "إقامة", // translated 
  transfers: "التحويلات", // translated 
  toursExperiences: "الجولات/التجارب", // translated 
  nights: "ليالي", // translated 
  days: "أيام", // translated 
  packageType: "نوع الحزمة", // translated 
  tourType: "نوع الجولة", // translated 
  packages: "الحزم", // translated 
  cars: "سيارات", // translated 
  cruises: "الرحلات البحرية", // translated 
  infantsInSeat: "الرضع في المقعد", // translated 
  infantsOnLap: "الرضع في اللفة", // translated 
  airport: "مطار", // translated 
  passengers: "ركاب", // translated 
  departureReturn: "مواعيد المغادرة والعودة", // translated 
  origin: "أصل", // translated 
  roundTrip: "جولة", // translated 
  isRoundTrip: "هي رحلة ذهابا وإيابا", // translated 
  dream_packages: "باقة الأحلام", // translated 
  partying: "الحفلات", // translated 
  thingsToDo: "الأشياء الذي ينبغي فعلها", // translated 
};



export default mainSearchForm;
